import { render, staticRenderFns } from "./TemplateClientPersonalization.vue?vue&type=template&id=a81954e4"
import script from "./TemplateClientPersonalization.vue?vue&type=script&lang=js"
export * from "./TemplateClientPersonalization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports